import { ObservableArray, View, ViewModel, ViewModelMessage } from "binder";
import moment from "moment";
import { FormExecutorViewModel, NodeExecutorRequestShowingPopupMessage, RequestCloseFormExecutorMessage, StartLoadingMessage, StopLoadingMessage } from "src/bpms/execution/formExecutor/formExecutor-viewModel";
import { GenericSearchableSelector, GenericSelector } from "src/common/reusableComponents/genericSelector";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { FileChooser, DateToString, stringIsNullOrEmpty, isValidIranianNationalId, isValidIranianPhoneNumber } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { FilteringInformation } from "src/uicomponents/components/extable/serverFilteringTable";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import { downloadFile, getAsBoolean, getAsNumber, getAsNumberNullAllowance } from "src/uicomponents/components/utilities";
import { CsvExporter } from "src/utilities/csv-exporter";
import { Enum, PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { methodBodyCreator } from "./methodBodyCreator";
import { BooleanType, DataModelClass as DataModelClass, ClassProperty, ClassType, DataModel, FloatType, IntegerType, IPropertyTypeVisitor, KnownClassType, ListType, StringType, VoidType, ClassFunction, ServerSideDataLoaderType, DateTypeDefaultValues, DateType, ChartSeriesType } from "./structure";
import { CurrentCredentials } from "src/server/currentCredentials";
import { LocalNotification } from "src/server/localNotification";
declare var currentSystemLanguage;

// declare var Stimulsoft: any;
import { Stimulsoft } from "types/stimulsoft.reports";
import { RequestShowingPdfMessage, WindowContainerViewModel, WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { CreateWindowMessage } from "src/common/userMainWindow/userMainWindow-viewModel";
import { ChartSeries, Datum, SingleDataSeries } from "src/uicomponents/components/chart/chart-viewModel";
import { SharedSelectors } from "src/erp/sharedSelectors";

export class ClassGenerator {

    public generateClasses(dataModel: DataModel, parent: ViewModel, withCodeExecution: boolean = true): CompiledClass {
        let a = moment;

        let model = new CompiledClass(parent);
        model.__DataModel__ = dataModel;
        dataModel.classes.forEach(element => {
            let cls = this.generateClass(dataModel, element, model, withCodeExecution);
            Object.defineProperty(model, element.name, {
                configurable: true,
                get: function () { return this[`_${element.name}`]; },
                set: function (v) { this[`_${element.name}`] = v; }
            });
            model[`_${element.name}`] = cls;
        });
        return model;
    }
    private generateClass(dataModel: DataModel, element: DataModelClass, parent: ViewModel, withCodeExecution: boolean): CompiledClass {
        let clss = new CompiledClass(parent);
        clss.__DataModelClass__ = element;
        clss.__DataModel__ = dataModel;
        element.GetMethods().forEach(x => {
            new MethodDefiner().defineMethod(clss, x, withCodeExecution);
        });
        element.GetProperties().forEach(x => {
            new PropertyDefiner().defineProperty(clss, x, withCodeExecution);
        });
        new PropertyInitializerGenerator().initializeProperties(clss, element.GetProperties());
        return clss;
    }
}

class PropertyInitializerGenerator implements IPropertyTypeVisitor {
    private clss: CompiledClass;
    private property: ClassProperty;
    private initializer: any[];
    initializeProperties(clss: CompiledClass, properties: ClassProperty[]) {
        this.clss = clss;
        this.initializer = [];
        properties.filter(x => x.shallInitialize == true).forEach(x => {
            this.property = x;
            this.property.propertyType.Accept(this, null);
        });
        let initializer = this.initializer;
        clss.Initialize = function () {
            let self = this;
            for (let i = 0; i < initializer.length; i++) {
                initializer[i].call(self);
            }
        }
        this.clss = null;
        this.property = null;
        this.initializer = null;
    }

    visitBooleanType(arg0: BooleanType, parameter: any) {
        let propertyName = this.property.name;
        let value = this.property.default;
        this.initializer.push(function () { this[propertyName] = value });
    }
    visitDateType(arg0: DateType, parameter: any) {
        let propertyName = this.property.name;

        switch (this.property.default.defaultValueType) {
            case DateTypeDefaultValues.Empty:
                this.initializer.push(function () { this[propertyName] = null });
                break;
            case DateTypeDefaultValues.Now:
                this.initializer.push(function () { this[propertyName] = moment.utc() });
                break;
            case DateTypeDefaultValues.TodayStart:
                this.initializer.push(function () { this[propertyName] = moment.utc().hour(0).minute(0).second(0).millisecond(0) });
                break;
            case DateTypeDefaultValues.TodayEnd:
                this.initializer.push(function () { this[propertyName] = moment.utc().hour(23).minute(59).second(59).millisecond(999) });
                break;
        }
    }

    visitIntegerType(arg0: IntegerType, parameter: any) {
        let propertyName = this.property.name;
        let value = this.property.default;
        this.initializer.push(function () { this[propertyName] = value });
    }
    visitFloatType(arg0: FloatType, parameter: any) {
        let propertyName = this.property.name;
        let value = this.property.default;
        this.initializer.push(function () { this[propertyName] = value });
    }
    visitStringType(arg0: StringType, parameter: any) {
        let propertyName = this.property.name;
        let value = this.property.default;
        this.initializer.push(function () { this[propertyName] = value });
    }
    visitListType(arg0: ListType, parameter: any) {
        let propertyName = this.property.name;
        this.initializer.push(function () { this[propertyName] = ObservableArray.create<ViewModel>() });
    }
    visitClassType(arg0: ClassType, parameter: any) {
        throw "not implemented exception";
    }
    visitKnownClassType(arg0: KnownClassType, parameter: any) {
        let propertyName = this.property.name;
        let dataModelClass = this.clss.__DataModel__.classes.filter(x => x.name == arg0.ForClass.name)[0];
        this.initializer.push(function () {
            this[propertyName] = dataModelClass.createInstance(this);
        });
    }
    visitServerSideDataLoaderType(arg0: ServerSideDataLoaderType, parameter: any) {
        let propertyName = this.property.name;
        let functionName = this.property.default.FunctionName;
        let pageSize = this.property.default.PageSize;
        let autoLoad = this.property.default.DisableAutoLoad;
        this.initializer.push(function () {
            let loader = new ServerSideDataLoader(this[functionName].bind(this), pageSize)
            loader.disableAutoLoad = autoLoad;
            this[propertyName] = loader;
        });
    }
    visitChartSeriesType(arg0: ChartSeriesType, parameter: any) {
        let propertyName = this.property.name;
        this.initializer.push(function () { this[propertyName] = new ChartSeries() });
    }

    visitVoidType(arg0: VoidType, parameter: any) {
        throw new Error("Method not implemented.");
    }

}

class PropertyDefiner implements IPropertyTypeVisitor {
    defineProperty(clss: CompiledClass, x: ClassProperty, withCodeExecution: boolean) {
        let preCode;
        let postCode;
        let nullCode;
        if (withCodeExecution) {
            preCode = new methodBodyCreator().createBodyText(x.preBody);
            postCode = new methodBodyCreator().createBodyText(x.postBody);
            nullCode = new methodBodyCreator().createBodyText(x.nullAllowanceBody);
        } else {
            preCode = '';
            postCode = '';
            nullCode = 'return false;'
        }
        if (stringIsNullOrEmpty(preCode)) {
            preCode = 'return true;'
        }
        let nullAllowanceFunc = Function(nullCode);
        let presetFunc = Function('oldValue', 'newValue', preCode);
        let PostSetFunc = Function('oldValue', 'newValue', postCode);
        let privateFieldName = `_${x.name}`;
        let nullAllowanceFuncName = `${x.name}NullAllowanceFunctionChecker`
        let preSetFunctionName = `${x.name}PreSetFunction`;
        let postSetFunctionName = `${x.name}PostSetFunction`;

        clss[nullAllowanceFuncName] = nullAllowanceFunc;
        clss[preSetFunctionName] = presetFunc;
        clss[postSetFunctionName] = PostSetFunc;

        let valueParserFunction = x.propertyType.Accept(this, null);

        let property = Object.defineProperty(clss, x.name, {
            configurable: true,
            get: function () { return this[privateFieldName] },
            set: function (notParsedValue) {
                let allowNull = this[nullAllowanceFuncName]();
                let v = valueParserFunction(notParsedValue, allowNull);
                let oldValue = this[privateFieldName];
                if (this[preSetFunctionName](oldValue, v) === true) {
                    this[privateFieldName] = v;
                    this[postSetFunctionName](oldValue, v)
                }
            }
        })

    }
    visitBooleanType(arg0: BooleanType, parameter: any) {
        return function (v, allowNull) { return getAsBoolean(v); };
    }
    visitDateType(arg0: DateType, parameter: any) {
        return function (v, allowNull) { return v; };
    }

    visitIntegerType(arg0: IntegerType, parameter: any) {
        return function (v, allowNull) {
            let value = getAsNumberNullAllowance(v, true, allowNull);
            if (value == null)
                return null;
            return Math.trunc(value);
        };
    }
    visitFloatType(arg0: FloatType, parameter: any) {
        return function (v, allowNull) { return getAsNumberNullAllowance(v, true, allowNull); };
    }
    visitStringType(arg0: StringType, parameter: any) {
        return function (v, allowNull) { return v; };
    }
    visitChartSeriesType(arg0: ChartSeriesType, parameter: any) {
        return function (v, allowNull) { return v; };
    }
    visitListType(arg0: ListType, parameter: any) {
        return function (v, allowNull) { return v; };
    }
    visitClassType(arg0: ClassType, parameter: any) {
        return function (v, allowNull) { return v; };
    }
    visitKnownClassType(arg0: KnownClassType, parameter: any) {
        return function (v, allowNull) { return v; };
    }
    visitVoidType(arg0: VoidType, parameter: any) {
        throw new Error("Method not implemented.");
    }
    visitServerSideDataLoaderType(arg0: ServerSideDataLoaderType, parameter: any) {
        return function (v, allowNull) { return v; };
    }

}
class MethodDefiner {

    defineMethod(clss: CompiledClass, x: ClassFunction, withCodeExecution: boolean) {
        let code
        if (withCodeExecution)
            code = new methodBodyCreator().createBodyText(x.body);
        else
            code = ''
        let f = null;
        try {
            if (x.isAsync) {
                const AsyncFunction = (async function () { }).constructor;
                f = AsyncFunction(...x.arguments.map(a => a.name), code);
            } else {
                f = Function(...x.arguments.map(a => a.name), code);
            }
            clss[x.name] = f;
        } catch (ex) {
            alert(x.name + ex);
        }
    }

}
export class CompiledClass extends ViewModel implements IPopup {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this._Builder_TemplateSelector__ = null;
        this.importanthasselectorfunction = true;
    }

    Initialize() {

    }

    public set __DataModel__(v: DataModel) { this.___DataModel__ = v; } public get __DataModel__(): DataModel { return this.___DataModel__; } private ___DataModel__: DataModel;
    public set __DataModelClass__(v: DataModelClass) { this.___DataModelClass__ = v; } public get __DataModelClass__(): DataModelClass { return this.___DataModelClass__; } private ___DataModelClass__: DataModelClass;
    public set _Builder_TemplateSelector__(v: ITemplateSelector) { this.__Builder_TemplateSelector__ = v; } public get _Builder_TemplateSelector__(): ITemplateSelector { return this.__Builder_TemplateSelector__; } private __Builder_TemplateSelector__: ITemplateSelector;
    public set importanthasselectorfunction(v: boolean) { this._importanthasselectorfunction = v; } public get importanthasselectorfunction(): boolean { return this._importanthasselectorfunction; } private _importanthasselectorfunction: boolean;

    public StringIsNullOrEmpty(value: string): boolean {
        return stringIsNullOrEmpty(value);
    }

    public IsValidIranianNationalId(value: string): boolean {
        return isValidIranianNationalId(value);
    }

    public IsValidIranianPhoneNumber(value: string, internal = true, international = false): boolean {
        return isValidIranianPhoneNumber(value, internal, international);
    }

    public __GetGuidEmpty(): string {
        return '00000000-0000-0000-0000-000000000000'
    }
    public __GetClassName__(): string {
        return this.__DataModelClass__.name;
    }

    public async __chooseFile(): Promise<{
        filename: string,
        fileContent: string,
        isChoosed: boolean
    }> {
        var chooser = new FileChooser();
        return chooser.chooseFile();
    }

    public __downloadFile(b64content: string, filename: string) {
        downloadFile(b64content, filename);
    }

    public __AddEnumToFilteringInformation__(filteringInformation: any, newFilter: { Name: string, Values: number[] }) {
        return this.__AddToFilteringInformation__(filteringInformation, {
            Type: "enum",
            Name: newFilter.Name,
            Values: newFilter.Values
        });
    }

    public __GetLoggedInUserInfo(): { username: string, personnelCode: string, personnelId: string, personnelFullName: string } {
        return {
            personnelId: CurrentCredentials.personnelId,
            personnelCode: CurrentCredentials.personnelCode,
            personnelFullName: CurrentCredentials.personnelFullName,
            username: CurrentCredentials.username
        };
    }
    public __AddToFilteringInformation__(filteringInformation: any, newFilter: any) {
        if (filteringInformation == null) {
            filteringInformation = {};
        }

        if (filteringInformation.Filters == null) {
            filteringInformation.Filters = {};
        }
        let filterString = filteringInformation.Filters.FilterString;
        let filter = [];
        if (stringIsNullOrEmpty(filterString) == false) {
            filter = JSON.parse(filterString);
        }
        filter.push(newFilter);
        filterString = JSON.stringify(filter);
        filteringInformation.Filters.FilterString = filterString;
        return filteringInformation;
    }
    public __GetEnumTranslator__(parameter): Enum {
        return this.handleMessage(new GetEnumTranslatorMessage(parameter[0], parameter[1]));
    }
    public __TranslateEnum__(parameter): string {
        let value = parameter[0];
        let processId = parameter[1];
        let enumName = parameter[2];
        return this.handleMessage(new GetEnumTranslationMessage(value, processId, enumName));
    }
    public __CreateNewInstance__(parent: ViewModel): CompiledClass {
        let result = <CompiledClass>Object.create(this);
        result.RealConstructor(parent);
        result.Initialize();
        if (result['OnLoad'])
            result['OnLoad']();

        result._Builder_TemplateSelector__ = (<any>parent)._Builder_TemplateSelector__;
        return result;
    }
    public __CreatePaginationInfo(current: number, total: number): PaginationInfo {
        return new PaginationInfo(current, total);
    }
    public __CreateChartSeries(): ChartSeries {
        return new ChartSeries()
    }
    public __CreateChartSingleDataSeries(): SingleDataSeries {
        return new SingleDataSeries()
    }
    public __CreateChartDatum(): Datum {
        return new Datum()
    }
    public __CreateChildInstanceFromTypeName(typeName: string): CompiledClass {
        let cls = this.__DataModel__.GetCompliledClassByName(typeName);
        return cls.__CreateNewInstance__(this);
    }

    public __CreateSharedComboBox(name: string): SelectorBaseViewModel<any> {
        return SharedSelectors.Selectors.get(name)(this);
    }

    public __CreateComboBox(isMultiSelect: boolean, searchable: boolean, autorefresh: boolean = true): ViewModel {
        if (isMultiSelect) {
            return null;
        } else {
            if (searchable) {
                let result = new GenericSearchableSelector(this);
                return result;
            } else {
                let result = new GenericSelector(this, !autorefresh);
                return result;
            }
        }
    }

    public __ExportCsv(fileName: string, exportingData: any[]) {
        CsvExporter.exportToCsv(`${fileName}.csv`, exportingData);
    }

    public __ConvertToPersianDate(d: moment.Moment, format?: string): string {
        if (format == null) {
            format = `HH:mm:ss YYYY/MM/DD`;
        }
        return DateToString(d, currentSystemLanguage, format, true);
    }

    public async __ShowPopup(popup: IPopup, template: string, width?: string, height?: string): Promise<any> {
        let request = new NodeExecutorRequestShowingPopupMessage();
        request.popup = popup;
        request.template = template;
        request.width = width;
        request.height = height;
        let result = await this.handleMessage(request);
        return result;
    }
    public async __PrintReport(reportId: string, data: any, copyCount: number) {
        reportId = reportId.substring(reportId.length - 36);
        let result = await this.__CallServer('/Complex/ReportServices/PrintReportFromClientSideData', {
            ReportId: reportId,
            Data: JSON.stringify(data),
            CopyCount: copyCount
        });
        let msg = new RequestShowingPdfMessage();
        msg.pdf = result.PdfFile;
        this.handleMessage(msg);
    }

    public async __PrintReportAsExcel(reportId: string, data: any, fileName: string) {
        reportId = reportId.substring(reportId.length - 36);
        let result = await this.__CallServer('/Complex/ReportServices/PrintReportFromClientSideData', {
            ReportId: reportId,
            Data: JSON.stringify(data),
            ExportExcel: true
        });
        let b64 = result.PdfFile;
        downloadFile(b64, `${fileName}.xlsx`);
    }

    closePopup(result?: any) {
    }

    public async __CallServer(address: string, parameter: any) {
        try {
            // if(this['IsLoading']){
            //     this['IsLoading'] = true;
            // }
            this.handleMessage(new StartLoadingMessage())
            let result = await ServerConnection.callServer(address, parameter);
            return result;
        } catch (ex) {
            console.log(ex);
            throw ex;
        } finally {
            this.handleMessage(new StopLoadingMessage())
            // if(this['IsLoading']){
            //     this['IsLoading'] = false;
            // }
        }
    }

    public async __OpenWindow(windowId: string, isProcessForm?: boolean, processFormId?: string, processFormName?: string): Promise<ViewModel> {
        let msg = new CreateWindowMessage(windowId);
        msg.isProcessForm = isProcessForm;
        msg.processFormId = processFormId;
        msg.processFormName = processFormName;
        let result = await this.handleMessage(msg);
        result = (<WindowContainerViewModel>result).window;
        if (result instanceof FormExecutorViewModel) {
            result = await result.getViewModel();
        }
        return result;
    }

    public __closeWindow() {
        this.handleMessage(new RequestCloseFormExecutorMessage());
    }
}

export class GetEnumTranslatorMessage extends ViewModelMessage {
    public processId: string;
    public enumName: string;

    /**
     *
     */
    constructor(processId: string, enumName: string) {
        super();
        this.processId = processId;
        this.enumName = enumName;
    }
}

export class GetEnumTranslationMessage extends ViewModelMessage {
    public processId: string;
    public enumName: string;
    public value: number;

    constructor(value: number, processId: string, enumName: string) {
        super();
        this.value = value;
        this.processId = processId;
        this.enumName = enumName;
    }
}